<style src="./Stock.scss" lang="scss" scoped></style>
<template>
  <section class="stock">
    <content-header path="Cadastro / Estoque"/>

    <form v-on:submit.prevent="">
      <section class="form-box row">
        <textbox
          v-model="filter.searchText"
          label="Buscar produto"
          placeholder="Digite o nome do produto"
          :class="{'col-9': showInsertNew, 'col-12': !showInsertNew}"
          :autofocus="true"
          :debounce="250"
          @debounce="searchStock"/>

        <button class="btn-primary col-3" @click="addNew" v-if="showInsertNew">
          <icon-add />
          <span class="hide-md">Atualizar estoque</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <page-navigator
        :total-pages="paginator.totalPage"
        :per-page="paginator.perPage"
        v-model="paginator.actualPage" />

      <stock-map
        :list="filteredList"
        @edit-max-price="editMaxPrice"
        @edit-item="editItem" />
    </section>

    <right-side-panel ref="rspNewStock" title="ATUALIZAR ESTOQUE" :shortcut="['alt', 'n']">
      <new-stock @refresh-list="refreshList" />
    </right-side-panel>

    <right-side-panel ref="rspEditMaxPrice" title="Anexar Preço Máximo" width="600px">
      <edit-max-price :edit-max-price="editMaxPriceItem" @confirmed-edit="maxPriceEdited"/>
    </right-side-panel>

    <right-side-panel ref="rspEditItem" title="Editar Item" width="600px">
      <edit-item
        :item-details="editItemDetails.details"
        :item-idx="editItemDetails.idx"
        @confirmed-edit="maxPriceEdited"/>
    </right-side-panel>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { NewStock, StockMap, EditItem } from './components'
import EditMaxPrice from '@/view/record/cmed/components/right-panel/edit-max-price/EditMaxPrice'
import { Textbox, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { SearchStock } from '@/brain/record/stock'

export default {
  name: 'Stock',
  components: {
    ContentHeader,
    RightSidePanel,
    NewStock,
    StockMap,
    EditMaxPrice,
    EditItem,
    Textbox,
    IconAdd,
    IconEmpty,
    PageNavigator
  },
  extends: {
    ...SourcePaginatorMixin
  },
  data () {
    return {
      filter: {
        searchText: ''
      },
      filteredList: [],
      editMaxPriceItem: {
        item: null,
        itemIndex: null
      },
      editItemDetails: {
        details: null,
        idx: null
      }
    }
  },
  watch: {
    paginator: {
      handler () {
        this.searchStock()
      },
      deep: true
    }
  },
  computed: {
    showInsertNew () {
      return this.$route.meta.mainArea !== 'research'
    }
  },
  methods: {
    addNew () {
      this.$refs.rspNewStock.showPanel()
    },
    refreshList () {
      // this.loadAll()
    },
    searchStock () {
      if (this.filter.searchText.length < 1) {
        this.filteredList = []
        this.paginator.totalRegister = 0
        this.paginator.totalPage = 0
        return false
      }
      const params = this.buildQuery({ filters: this.filter })

      SearchStock({ params })
        .then((result) => {
          this.filteredList = result.list
          this.paginator.totalRegister = result.rows
          this.paginator.totalPage = Math.floor(result.rows / this.paginator.perPage)
        })
    },
    editMaxPrice ({ item, itemIndex }) {
      this.editMaxPriceItem.item = item
      this.editMaxPriceItem.itemIndex = itemIndex
      this.$refs.rspEditMaxPrice.showPanel()
    },
    maxPriceEdited () {
      this.searchStock(this.filter.searchText)
    },
    editItem ({ item, itemIdx }) {
      this.editItemDetails = {
        idx: itemIdx,
        details: item
      }
      this.$refs.rspEditItem.showPanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/stock/Stock.vue